import { install } from '@material-ui/styles'

install()

localStorage.debug = 'heimdall:*'
